var map = {
	"./wban-logo-arbitrum.svg": "dcd3",
	"./wban-logo-bsc.svg": "7a70",
	"./wban-logo-ethereum.svg": "0ee65",
	"./wban-logo-fantom.svg": "619f",
	"./wban-logo-polygon.svg": "92a3"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7797";
module.exports = webpackAsyncContext;